
export default {
  name: 'nonInteractiveMaterial',
  data: function data() {
    return {
      activeName: 'slogan',
      tab: [{
        label: '文案库',
        value: 'slogan'
      }, {
        label: '图片库',
        value: 'picture'
      }, {
        label: '视频库',
        value: 'video'
      }, {
        label: '音乐库',
        value: 'audio'
      }, {
        label: '字体库',
        value: 'font'
      }]
    };
  },

  methods: {
    handleClick: function handleClick() {
      this.$router.push({
        path: '/repo/non-itav-material/' + this.activeName
      });
    },
    getActiveName: function getActiveName() {
      var _this = this;

      // router/repository.js里面itav-material路由中的meta.title与tab.label一致，所以可以以这个title做为判断
      return (this.tab.find(function (item) {
        return item.label === _this.$route.meta.title;
      }) || {}).value;
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.activeName = this.getActiveName();
    }
  },
  mounted: function mounted() {
    this.activeName = this.getActiveName();
  }
};